import ItemPartViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemPartViewState';
import { ClientItem } from 'owa-mail-store';
import { getLabelFromStore } from 'owa-mail-protection/lib/utils/clp/getExistingCLPInfo';
import {
    InfoBarMessageColor,
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function tryCreateCLPLabelInfoBarMessage(
    message: ClientItem,
    key: string,
    viewstate: ItemPartViewState
): InfoBarMessageViewState {
    if (!viewstate.shouldShowCLPLabel) {
        return null;
    }

    const label = getLabelFromStore(message.MSIPLabelGuid);
    if (label) {
        const rank = label.isEncryptingLabel
            ? InfoBarMessageRank.Encryption
            : InfoBarMessageRank.Sensitivity;

        const infoBarMessageViewState: InfoBarMessageViewState = {
            key: key,
            source: InfoBarMessageSource.ReadingPane,
            rank: rank,
            color: InfoBarMessageColor.Grey,
            message: label.infobarDisplayText,
            messageParts: [label.infobarDisplayText],
        };
        return infoBarMessageViewState;
    }
    return null;
}
